import { ISSUE_VIEW_URL_REGEX } from './constants.tsx';

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const isIssueViewPage = () => window.location.pathname.match(ISSUE_VIEW_URL_REGEX);
